<div class="bg-image-dashed-cloud"></div>

<div class="maintenance-container">
  <img
    [src]="branding.logo"
    class="brand-logo"
    [class.brand-wordmark]="branding.wordmarkLogo"
    [class.logo-invert]="branding.logoInvert"
    [alt]="branding.logoAlt"
    [title]="branding.logoAlt"
  />

  <h1 class="error-message">System Maintenance in Progress!</h1>
  <div class="flex items-center justify-center gap-2 mb-14">
    <rkt-icon class="schecule-icon" name="schedule" />
    <p class="maintenance-text">{{ branding.productName }} is under scheduled maintenance</p>
  </div>

  <div class="maintenance-text mb-6">
    <p class="mb-4">Good things are happening! We will be back shortly. We're sorry for the inconvenience.</p>
    <p>
      For questions or immediate assistance, please contact us at
      <a
        [href]="branding.contactHref"
        [attr.target]="branding.contactInNewTab ? '_blank' : null"
        rel="noopener noreferrer"
        class="contact-link"
        >{{ branding.contactLabel }}</a
      >
    </p>
  </div>
</div>
